import { defineComponent as _defineComponent } from 'vue'
import { setGrowthDayRecord } from '@/api/task'
import { reactive, onDeactivated, onMounted } from 'vue'
import { useUserStore } from '@/store/modules/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'MTaskTime',
  props: {
  type: Number,
  isRun: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const userStore = useUserStore()



let taskTimer: any

const state = reactive({
  recordToken: '0',
  oldRead: 0,
  interval: 30e3,
})

onMounted(() => {
  taskTimer = setInterval(() => {
    uploadData()
  }, state.interval)
  // 立即执行初始化
  uploadData(true)
})

const uploadData = async (isInit?: boolean) => {
  // 非会员不计算时间
  if (!userStore?.userInfo?.memberDto?.isValiddMember) return false

  // 停止任务
  if (!props.isRun && !isInit) {
    return false
  }

  const data = [
    { newRead: state.oldRead, t: state.recordToken, type: props.type },
  ]
  const { ret, dataList } = await setGrowthDayRecord(data)
  if (ret === 100) {
    state.oldRead = dataList[0].oldRead + state.interval
    state.recordToken = dataList[0]?.t
  }
}

onDeactivated(() => {
  clearInterval(taskTimer)
})

return () => {}
}

})